// import { tWithKeyAttr as t } from "../../i18nHelper";
import styles from "./statusButton.module.css";
import React, { useState } from "react";
import { useAppSelector } from "../../services/hooks";
import { TTherapistWithUsers, TUsersWithOutTherapist } from "../../services/types/auth.types";
import { inquiryStatusesSelector } from "../../services/selectors/utils.selectors";
import { getStatusClass, getServerStatusText } from "../../utils/utils";

function StatusButton({
  document,
  onStatusChange,
  updatable,
}: {
  document?: TTherapistWithUsers | TUsersWithOutTherapist;
  onStatusChange: (newStatusId: number) => void;
  updatable?: boolean;
}) {
  const serverStatuses = useAppSelector(inquiryStatusesSelector);
  const status =
    serverStatuses.find(
      (s) =>
        s.id ===
        document?.status) || undefined;
  const statusId = status?.id || 0;
  const [toggle, setToggle] = useState({});
  const id =
    document?.num.toString() || "0";
  const toggleStatusOptions = (id: string) => {
    setToggle({ [id]: !toggle[id as keyof typeof setToggle] });
  };
  if (!document) return null;
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        toggleStatusOptions(id);
      }}
      className={`${styles.statusContainer} ${styles.status} ${
        status && styles[getStatusClass(statusId)]
      }`}
    >
      <span className={styles.statusPoint} />
      {getServerStatusText(statusId, serverStatuses)}
      {updatable && (
        <ul
          className={`${styles.statusOptionsList} ${
            toggle[id as keyof typeof setToggle] &&
            styles.statusOptionsList_visible
          }`}
        >
          {serverStatuses.map(
            (s) =>
               (
                <li
                  key={s.id}
                  className={`${styles.statusOptionsItem} ${
                    styles[getStatusClass(s.id)]
                  }`}
                  onClick={() => onStatusChange(s.id)}
                >
                  {getServerStatusText(s.id, serverStatuses)}
                </li>
              )
          )}
        </ul>
      )}
    </div>
  );
}
export default StatusButton;
